<template>
  <div class="pt-navigation-desktop">
    <ContentSection spacing="none" class="pb-16 sm:py-28">
      <!-- HIDDEN TITLE FOR ACCESSIBILITY -->
      <h1 class="sr-only">
        {{ $t('search.search') }}
      </h1>
      <Search />
    </ContentSection>
  </div>
</template>

<script setup>
const { setIsWhite } = useNavigationStore()

const { locales } = useI18n()
const switchLocalePath = useSwitchLocalePath()
const alternates = useState('alternates', () => [])
alternates.value = locales.value.map((l) => ({
  locale: l.code,
  url: switchLocalePath(l.code),
}))

onMounted(() => {
  setIsWhite(false)
})

onBeforeUnmount(() => {
  setIsWhite(false)
})
</script>
